import { Backdrop } from '@mui/material';
import UPButton from 'components/button';
import { useTranslation } from 'react-i18next';
import { GENERAL__CLOSE, KIOSK__PIN_NOT_SET_BODY, KIOSK__PIN_NOT_SET_TITLE } from 'translations/constants';
import ModalProps from 'types/common/ModalProps';
import {
  KioskModalActions,
  KioskModalContainer,
  KioskModalStyled,
  KioskModalSubtitle,
  KioskModalTitle,
} from '../styles';

/** No PIN setup on the kiosk (US requirement) — this just sends the employee back to the list. */
const KioskNoPinNotice = ({ open, onClose }: ModalProps) => {
  const [t] = useTranslation();

  return (
    // zIndex above KioskHeaderRow's 3 so the persistent reload/exit buttons dim under the backdrop too.
    <Backdrop open={open} sx={{ zIndex: 4 }}>
      <KioskModalStyled open={open} onClose={onClose}>
        <KioskModalContainer>
          <KioskModalTitle>{t(KIOSK__PIN_NOT_SET_TITLE)}</KioskModalTitle>
          <KioskModalSubtitle>{t(KIOSK__PIN_NOT_SET_BODY)}</KioskModalSubtitle>
          <KioskModalActions>
            <UPButton text={t(GENERAL__CLOSE)} onClick={onClose} />
          </KioskModalActions>
        </KioskModalContainer>
      </KioskModalStyled>
    </Backdrop>
  );
};

export default KioskNoPinNotice;
